<template>
    <div >
<!--        <h2 class="scr-title animate fadeInUp" >Trayton Group aligns our efforts<br>-->
<!--            with the UN SDGs<br>-->
<!--            (UN Sustainable Development Goals)</h2>-->
<!--        <img class="csr1 animate opacityIn" src="../../../assets/images/csr1.jpg" alt="csr1">-->
        <div class="csr-2 ">
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_04.jpg" alt="csr1">
                    </div>
                </swiper-slide>
              <swiper-slide >
                <div class="swiper-img">
                  <img src="../../../assets/images/csr_swiper_01_07.jpg" alt="csr1">
                </div>
              </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_05.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_01_06.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="right">
                <swiper class="swiper-box"  :options="swiperOptions1" >
                    <swiper-slide >
                        <div class="swiper-img">
                            <div class="animate fadeInRight">
                                <h2 class="">OUR PEOPLE</h2>
                                <p class="">We are all very proud to work for Trayton , and we have nurtured a culture of quality and responsibility at every level of our organization. Everyone at Trayton takes great interest and responsibility in ensuring that we continually develop and improve our products and our quality, while maintaining a competitive costing structure through maximized efficiency. Together, we are building a sustainable and competitive Trayton by employing a unique combination of best practices gleaned from the unique experiences of our diverse international team. </p>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide >
                        <div class="swiper-img">
                            <div class="animate fadeInRight">
                                <h2 class="">OUR PEOPLE</h2>
                                <p class="">We share a common passion for what we do, and we care deeply for the needs of our customers, as well as for the planet and the people with whom we share it. Our unique management and business model involves everyone in the company, which can be summarized as a very flat organization where everyone understands our goals and principles, and feels they are a part of the success of the company. At Trayton , we love what we do!</p>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
        <div class="csr-2">
            <div class="right" style="padding: 3vw 0 0 0">
                <div class="animate fadeInLeft">
                    <div class="row-1 " >
                        <img class="img " src="../../../assets/images/csr3.png" alt="">
                        <h2 class="" style="padding: 1vw 0 0 0">UNGC (United Nations Global Compact)</h2>
                    </div>
                    <div class="">
                        <p class="">In October 2023, at the "Forward Faster" CEO Roundtable held in Shanghai, China, Simon Lichtenberg, Founder and CEO of Trayton Group, met with Sanda Ojiambo, Assistant Secretary-General and Executive Director of the United Nations Global Compact (UNGC), to discuss the responsibilities and opportunities of businesses in global sustainable development.</p>
                        <p class="">As one of the earliest Chinese companies to join the UNGC, Trayton Group successfully completed the SDG Innovation Accelerator for Young Professionals in 2023 and passed the Climate Ambition Accelerator (CAA) program in 2024, further deepening its commitment to sustainable development.</p>
                    </div>
                </div>
            </div>
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_02_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="csr-2">
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_03_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_03_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
            <div class="right">
                <div class="animate fadeInRight">
                  <div class="row-1 ">
                    <h2 class="" >SBTi (Science-Based Targets initiative)</h2>
                  </div>
                    <p >In May 2024, Trayton successfully obtained official verification from SBTi, becoming the first furniture company in China to achieve this certification. This milestone marks a significant step in Trayton’s climate action journey, reinforcing its commitment to science-based carbon reduction and sustainable development.</p>
                  <p><router-link to="/pdfEn" style="color: #333;text-decoration: underline">Trayton Group Climate Positive Action Process Annual Disclosure</router-link></p>
<!--                  <p><a href="https://www.simonli.cn/tech.html" style="color: #333;text-decoration: underline">Trayton Group Climate Positive Action Process Annual Disclosure</a></p>-->
                </div>
            </div>
        </div>
        <!--        <h2 class="scr-title animate fadeInUp">SBTi Committed and Approved for CO2 and other GHG<br>-->
        <!--            deductionsScope 1, 2 and 3</h2>-->
        <!--        <h2 class="scr-title animate fadeInUp">Trayton is the first furniture enterprise in China<br>-->
        <!--            to have been validated by SBTi<br>-->
        <!--            特雷通是中国首家通过SBTi验证的家具企业</h2>-->
        <!--        <img class="csr-5 animate opacityIn" src="../../../assets/images/csr5.png" alt="">-->
        <!--        <img class="csr-6 animate opacityIn" src="../../../assets/images/csr6.jpg" alt="">-->
        <div class="logos">
            <h2 class="scr-title animate fadeInUp">SUSTAINABILITY</h2>
            <img class="csr-7 animate opacityIn" src="../../../assets/images/csr7.jpg" alt="">
        </div>
        <div class="csr-2 ">
            <div class="right">
                <div class="animate fadeInLeft">
                    <h2 class="">THE REED PROJECT</h2>
                    <div class="">
                        <p >There are 12 million rural children without preschool education in China, and about 20 million children in China without quality preschool education. Early education plays a vital role in people’s later adult life, and is the most cost effective way to improve the living conditions of people in poor and backward areas.</p>
                        <p >This is the reason why we established the Rural Early Childhood Development Education Fund (REED). Donors of REED are business elites in China and elsewhere.</p>
                    </div>
                </div>
<!--                <p class="animate fadeInRight">REED started the first six preschool classes for children aged 3 to 6 in Butuo County, Sichuan, in 2014. Today we run 100 classes in 60 villages in the county. We train, manage and support the 200 teachers who teach and care for the students of those 100 classes in Butuo County, Liangshan Prefecture in a very close cooperation with the government and Bureau of Education, Sports and Science and Technology of Butuo County. Over 4,500 children get to preschool every day, get a solid meal and high-quality early education that will help them get a good start in life. Learning Mandarin is particularly important for minority children, like the Yi Minority children in Butuo.</p>-->
<!--                <p class="animate fadeInRight">Shanghai Huji Foundation is doing the actual work, implementing the "Preschool of the Future" concept in the local area. The concept employs modern child-centered early education while following the guidelines of the PRC Ministry of Education for preschools, improving the quality of preschools in remote rural villages. REED is very proud to work closely together with Shanghai Huji Foundation team working side by side with the children, the parents and the teachers in their villages.</p>-->
<!--                <p class="animate fadeInRight">Many more children are in need of such support. We welcome more government agencies, partners, parents and community organizations to work together on early childhood education in remote areas.</p>-->
            </div>
            <swiper class="left swiper-box animate opacityIn"  :options="swiperOptions1" >
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_01.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_02.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_03.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_04.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_05.jpg" alt="csr1">
                    </div>
                </swiper-slide>
<!--                <swiper-slide >-->
<!--                    <div class="swiper-img">-->
<!--                        <img src="../../../assets/images/csr_swiper_04_06.jpg" alt="csr1">-->
<!--                    </div>-->
<!--                </swiper-slide>-->
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_07.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_08.jpg" alt="csr1">
                    </div>
                </swiper-slide>
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_09.jpg" alt="csr1">
                    </div>
                </swiper-slide>+
                <swiper-slide >
                    <div class="swiper-img">
                        <img src="../../../assets/images/csr_swiper_04_10.jpg" alt="csr1">
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CsrContent3',
        data () {
            return {
                swiperOptions1: {
                    pagination: '.swiper-pagination-1',
                    paginationClickable :true,
                    autoplayDisableOnInteraction : false,
                    loop: true,
                    autoplay : 3000,
                    speed: 1000,
                    effect : 'fade',
                }
            }
        },
    }
</script>
<style lang="scss" scoped>
@use 'styles/common' as *;
.swiper-slide {
    opacity: 0 !important;
}
.swiper-slide-active {
    opacity: 1 !important;
}
.scr-title {
    font-family: "Regular" !important;
    font-size: 1.8vw;
    line-height: 1.5;
    text-align: center;
    @include respond-to() {
        font-size: 3.4vw;
    }
}
.row-1 {
    //padding: 7vw 0 0 0;
    //display: flex;
    //align-items: center;
  text-align: center;
  img {
    @include respond-to() {
      margin: 0 0 3vw 0;
    }
  }
    h2 {
        margin: 0 0 0 0 !important;
        //width: 72%;
        @include respond-to() {
          margin: 0 0 7vw 0 !important;
            width: 100%;
        }
    }
}
.csr1 {
    display: block;
    margin: 5vw auto 10vw;
    width: 62.5%;
}
.csr-2 {
    //margin-bottom: 5vw;
    display: flex;
    flex-wrap: nowrap;
    background: #f4f3ee;
    @include respond-to() {
        display: block;
    }
    .left {
        width: 50%;
        @include respond-to() {
            width: 100%;
        }
        img {
            width: 100%;
            object-fit: cover;
        }
    }
    .right {
        box-sizing: border-box;
        //padding: 7vw 7% 0 7%;
        padding: 7vw 0 0 0;
        width: 50%;
      @include respond-to() {
        padding: 7vw 0 7vw 0 !important;
        width: 100%;
      }
        h2 {
            //padding: 7vw 0 0 0;
            margin-bottom: 3vw;
            font-size: 2vw;
            text-align: center;
            font-family: AvantGarde;
            @include respond-to() {
                margin: 6vw 0 8vw 0;
                font-size: 4vw;
            }
        }
        @include respond-to() {
            //padding: 7vw 7% 7vw 7%;
            width: 100%;
        }
        img {
            width: 7vw;
        }
        p {
            margin-top: 2vw;
            padding: 0 7%;
            font-size: 0.938vw;
            line-height: 1.5;
            font-family: AvantGarde;
            @include respond-to() {
                font-size: 10px;
            }
        }
      p:first-child {
        @include respond-to() {
          margin-top: 5vw;
        }
      }
    }
}
.csr-5 {
    display: block;
    margin: 5vw auto;
    width: 62.5%;
}
.csr-6 {
    display: block;
    margin: 5vw auto;
    width: 84%;
}
.csr-7 {
    display: block;
    margin: 0 auto 5vw;
    width: 62.5%;
    @include respond-to {
        width: 90%;
    }
}
.logos {
    margin: 7vw auto 0;
}
</style>

